import { useFeedState, useVideoHistory } from '~/composables/shorts';
import { usePropertyViewTracking } from '~/composables/usePropertyViewTracking';
import { useShortsFeedStore } from '~/store/shortsFeedStore';

export default defineNuxtPlugin(() => {
	const { loggedIn } = useUserSession();
	const { syncOfflineViews, getOfflineViewsCount } = usePropertyViewTracking();
	const feedState = useFeedState();
	const feedStore = useShortsFeedStore();
	const { resetHistory } = useVideoHistory();

	async function resetShortsClientCaches(): Promise<void> {
		// Preserve active filters so the feed can be reloaded with the same criteria
		const previousFilters = { ...feedStore.activeFilters };

		resetHistory();
		feedState.reset();

		// Always reload the feed so the carousel doesn't become empty,
		// preserving any active filters.
		await feedState.fetchFeed(previousFilters);
	}

	watch(loggedIn, async (isLoggedIn, wasLoggedIn) => {
		if (isLoggedIn && !wasLoggedIn) {
			const offlineCount = getOfflineViewsCount();
			if (offlineCount > 0) {
				try {
					await syncOfflineViews();
				} finally {
					// Skip cache reset while the user is actively on the shorts page
					// to avoid losing the current carousel position. Caches will be
					// refreshed on the next page load.
					const route = useRoute();
					if (!route.path.startsWith('/shorts')) {
						await resetShortsClientCaches();
					}
				}
			}
		}
	});
});
